import {BBModel} from '../bb_model';
import {context} from '../constants/context';
import {halClient} from '../hal';

const event = {
    query(company, params) {
        return new Promise((resolve, reject) => {
            if (!company.$has('events')) {
                resolve([]);
            } else {
                if (params.item) {
                    if (params.item.event_group) {
                        params.event_group_id = params.item.event_group.id;
                    }
                    if (params.item.event_chain) {
                        params.event_chain_id = params.item.event_chain.id;
                    }
                    if (params.item.resource) {
                        params.resource_id = params.item.resource.id;
                    }
                    if (params.item.person) {
                        params.person_id = params.item.person.id;
                    }
                }
                params.no_cache = true;
                company.$get('events', params).then((resource) => {
                        params.no_cache = false;
                        return resource.$get('events', params).then((events) => {
                                events = (Array.from(events).map(event => new BBModel.Event(event)));
                                return resolve(events);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    },

    async queryByParams(params={}) {
        const modelName = 'events';

        try {
            const result = {};
            const resource = await params.company.$get(modelName, params);
            if (params.summary && resource[modelName]) {
                result.items = resource[modelName];
            } else {
                result.items = await resource.$get(modelName);
                result.total_entries = resource.total_entries;
            }
            return result;
            
        } catch (err) {
            console.error(err);
        }
    },

    summary(company, params) {
        return new Promise((resolve, reject) => {
            if (!company.$has('events')) {
                resolve([]);
            } else {
                if (params.item) {
                    if (params.item.event_group) {
                        params.event_group_id = params.item.event_group.id;
                    }
                    if (params.item.event_chain) {
                        params.event_chain_id = params.item.event_chain.id;
                    }
                    if (params.item.resource) {
                        params.resource_id = params.item.resource.id;
                    }
                    if (params.item.person) {
                        params.person_id = params.item.person.id;
                    }
                }
                params.summary = true;
                company.$get('events', params).then((resource) => {
                        return resolve(resource.events);
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    },

    queryEventCollection(company, params) {
        return new Promise((resolve, reject) => {
            if (!company.$has('events')) {
                resolve([]);
            } else {
                if (params.item) {
                    if (params.item.event_group) {
                        params.event_group_id = params.item.event_group.id;
                    }
                    if (params.item.event_chain) {
                        params.event_chain_id = params.item.event_chain.id;
                    }
                    if (params.item.resource) {
                        params.resource_id = params.item.resource.id;
                    }
                    if (params.item.person) {
                        params.person_id = params.item.person.id;
                    }
                }
                company.$get('events', params).then((resource) => {
                        const collection = new BBModel.BBCollection(resource);
                        return resolve(collection);
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    },

    async queryById(companyId, eventId) {
        const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/events/${eventId}`;
        return new BBModel.Event(await halClient.$get(url), {});
    }
};

export {
    event
};
